import APIService from "./APIService";

export default class Api_spatial {

  //TODO:[Common] Get spatial huyen
  GetSpatialHuyens = async ({ token, tenhuyen } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialhuyen?tenhuyen=${tenhuyen}`,
      project: "cscore.spatial"
    });
  };

  //TODO:[Common] Get spatial tinh
  GetSpatialTinhs = async ({ token, tentinh } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialtinh?tentinh=${tentinh}`,
      project: "cscore.spatial"
    });
  };


  GetSpatialSearchApis = async ({ token = "", searchText } = {}) => {
    return new APIService({ token: token }).getData({
      path: `https://nominatim.openstreetmap.org/search/${searchText}?format=json&limit=1`,
      project: "others"
    });
  };

  GetSpatialXas = async ({ token, tenxa } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialxa?tenxa=${tenxa}`,
      project: "cscore.spatial"
    });
  };
  GetSpatialThuocDVHC = async ({ token, tenhuyen } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialthuocdvhc?tenhuyen=${tenhuyen}`,
      project: "cscore.spatial"
    });
  };

  //TODO
  GetSpatialClickInfor = async ({ token, geom } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialclickinfor?geom=${geom}`,
      project: "cscore.spatial"
    });
  };
  //
  GetSpatialCTByGP = async ({ token, idcongtrinh, loaicongtrinh } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TNNSpatial/getspatialctbygp?idcongtrinh=${idcongtrinh}&loaicongtrinh=${loaicongtrinh}`,
      project: "cscore.spatial"
    });
  };

  GetLVS_SC = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getdslvs`,
      project: "cscore.spatial"
    });
  };
  GetSpatialCTThuocLVS = async ({ token, idsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialctthuoclvs?idsong=${idsong}`,
      project: "cscore.spatial",
      data: idsong
    });
  };

  GetSpatialDXTThuocLVS = async ({ token, idsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialdxtthuoclvs?idsong=${idsong}`,
      project: "cscore.spatial",
      data: idsong
    });
  };

  GetSpatialLVSs = async ({ token, idlvsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatiallvs?gid=${idlvsong}`,
      project: "cscore.spatial"
    });
  };

  GetSpatialKTTVs = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialkttv`,
      project: "cscore.spatial"
    });
  };
  GetSpatialKKs = async ({ token } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialkk`,
      project: "cscore.spatial"
    });
  };
  // TODO: Danh sách song theo cap
  GetDSSong = async ({ token, strSearch } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getdssong`,
      data: { strSearch },
      project: "cscore.spatial"
    });
  };
  // TODO: Thong tin song
  GetSpatialSong = async ({ token, idsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialsong`,
      data: { idsong },
      project: "cscore.spatial"
    });
  };
  // TODO: Thong tin cong trinh thuoc song
  GetSpatialCTThuocSong = async ({ token, idsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialctthuocsong`,
      data: { idsong },
      project: "cscore.spatial"
    });
  };
  // TODO: Thong tin cong trinh thuoc song
  GetSpatialThuocLVS = async ({ token, idsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialthuoclvs`,
      data: { idsong },
      project: "cscore.spatial"
    });
  };
  // TODO: Kiểm tra vùng trên bản dồ
  CheckCongTrinhVung = async ({ token, toado, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QuanTracSpatial/checkvung?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}&toado=${toado}`,
      project: "cscore.spatial"
    });
  };
  // TODO: Kiểm tra điểm trên bản dồ
  CheckCongTrinhDiem = async ({ token, toado, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QuanTracSpatial/checkdiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}&toado=${toado}`,
      // data: toado,
      project: "cscore.spatial"
    });
  };

  // TODO: Thong tin spatial thuoc song
  GetSpatialThuocSong = async ({ token, idsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TNNSpatial/getspatialthuocsong`,
      data: { idsong },
      project: "cscore.spatial"
    });
  };

  GetSpatialDXTThuocSong = async ({ token, idsong } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TNNSpatial/getspatialdxtthuocsong`,
      data: { idsong },
      project: "cscore.spatial"
    });
  };

   // TODO: Thong tin cong trinh thuoc song
   GetSpatialCT = async ({ token, idcongtrinh,loaicongtrinh } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TNNSpatial/getspatialct`,
      data: {idcongtrinh,loaicongtrinh},
      project: "cscore.spatial"
    });
  };
  // TODO: Thong tin cong trinh thuoc song
  GetSpatialHM = async ({ token, idhangmuc } = {}) => {
    return new APIService({ token: token }).getData({
      path: `TNNSpatial/getspatialhm`,
      data: { idhangmuc },
      project: "cscore.spatial"
    });
  };
  GetSpatialDXT = async ({ token, iddiemxathai } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialdxt`,
      data: { iddiemxathai },
      project: "cscore.spatial"
    });
  };
  GetSpatialDQT = async ({ token, iddiemquantrac } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialdqt`,
      data: { iddiemquantrac },
      project: "cscore.spatial"
    });
  };
  GetSpatialTQT = async ({ token, idtramquantrac } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialtqt`,
      data: { idtramquantrac },
      project: "cscore.spatial"
    });
  };
  GetSpatialHTMT = async ({ token, iddiemquantrac, kyhieu } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialqt`,
      data: { iddiemquantrac, kyhieu },
      project: "cscore.spatial"
    });
  };

  // TODO: Tọa độ điểm QT
  LuuDiemQuanTrac = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QuanTracSpatial/diemquantrac?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    });
  };
  // TODO: Xóa toa do diem QT
  xoageodiemQT = async ({ token, iddiemquantrac, phanphanloaiquantrac } = {}) => {
    return new APIService({ token: token }).deleteData({
      path: `QuanTracSpatial/xoadiemquantrac?iddiemquantrac=${iddiemquantrac}&phanphanloaiquantrac=${phanphanloaiquantrac}`,
      project: "cscore.spatial"
    });
  };
  // TODO: Tọa độ tram QT
  LuuQuanTracDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token: token }).postData({
      path: `QuanTracSpatial/luuquantracdiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    });
  };
  // TODO: Xóa toa do tram QT
  xoageoTramQT = async ({ token, idtramquantrac, phanphanloaiquantrac } = {}) => {
    return new APIService({ token: token }).deleteData({
      path: `TNNSpatial/xoatramquantrac?idtramquantrac=${idtramquantrac}&phanphanloaiquantrac=${phanphanloaiquantrac}`,
      project: "cscore.spatial"
    });
  };

  post_CTDiem = async ({ token, point_CT, degree, minute, muiChieu } = {}) => {
    return new APIService({ token }).postData({
      path: `TNNSpatial/congtrinhdiem?ktt_do=${degree}&ktt_phut=${minute}&muichieu=${muiChieu}`,
      data: point_CT,
      project: "cscore.spatial"
    })
  };

  post_CTVung = async ({ token, area_CT, degree, minute, muiChieu } = {}) => {
    return new APIService({ token }).postData({
      path: `TNNSpatial/congtrinhvung?ktt_do=${degree}&ktt_phut=${minute}&muichieu=${muiChieu}`,
      data: area_CT,
      project: "cscore.spatial"
    })
  }

  GetSpatialTNNDiem = async ({ token, idtnn_tqt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialquantractnn`,
      data: { idtnn_tqt },
      project: "cscore.spatial"
    });
  }; 


  GetSpatialDTMDiem = async ({ token, iddtm } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialdtm`,
      data: { iddtm },
      project: "cscore.spatial"
    });
  }; 

  GetSpatialBVMTDiem = async ({ token, idbvmt } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialbvmt`,
      data: { idbvmt },
      project: "cscore.spatial"
    });
  }; 

  GetSpatialNTTSDiem = async ({ token, idntts } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialntts`,
      data: { idntts },
      project: "cscore.spatial"
    });
  }; 

  GetSpatialQDXPDiem = async ({ token, idqdxp } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialqdxp`,
      data: { idqdxp },
      project: "cscore.spatial"
    });
  }; 

  GetSpatialVHLDiem = async ({ token, idvhl } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialvhl`,
      data: { idvhl },
      project: "cscore.spatial"
    });
  }; 

  GetSpatialTQTDiem = async ({ token, idtqt,loaitram } = {}) => {
    return new APIService({ token: token }).getData({
      path: `QuanTracSpatial/getspatialtqt`,
      data: { idtqt,loaitram },
      project: "cscore.spatial"
    });
  };

  LuuQuanTracBVMTDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantracbvmtdiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }

  LuuQuanTracDTMDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantracdtmdiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }

  LuuQuanTracNTTSDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantracnttsdiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }

  LuuQuanTracTTKTDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantracttktdiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }

  LuuSpatialDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuspatialdiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }

  LuuQuanTracVHLDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantracvhldiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }
  //spatial dtm
  LuuQuanTracDTMDiem_Temp = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantracdtmdiem_temp?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }
  LuuQuanTracBVMTDiem_Temp = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantracbvmtdiem_temp?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }

  LuuQuanTracTNNDiem = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantractnndiem?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }

  LuuQuanTracTNNDiem_Temp = async ({ token, obj, ktt_do, ktt_phut, muichieu } = {}) => {
    return new APIService({ token }).postData({
      path: `QuanTracSpatial/luuquantractnndiem_temp?ktt_do=${ktt_do}&ktt_phut=${ktt_phut}&muichieu=${muichieu}`,
      data: obj,
      project: "cscore.spatial"
    })
  }


}